import Vuex from "vuex";
import Vue from "vue";
import {index} from "@/store/user/share/report.js";
import {viewIndex} from "@/store/user/share/view.js";
import {userReach} from "@/store/user/share/reach.js";
import {userTurnover} from "@/store/user/share/turnover.js";
import {evaluation} from "@/store/hvac/project/detail/evaluation";
import {construction} from "@/store/hvac/project/detail/construction";
import {custom} from "@/store/hvac/project/detail/custom";
import {projectDetailCustomBeijingOne} from "@/store/hvac/project/detail/beijing";
import {completion} from "@/store/member/project";
import {userTalkAppoint} from "@/store/hvac/talk/v1/index";
import {userTalkAppointV2} from "@/store/hvac/talk/v2/index";
import {userTalkAppointV3} from "@/store/hvac/talk/v3/index";
import {scoring} from "@/store/hvac/service/customerscoring/scoring";
import {particulars} from "@/store/hvac/service/particulars";
import {entry} from "@/store/hvac/mapping/entry";
import {memberProjectMapping} from "@/store/member/project/mapping";
import {serviceScoreDetail} from "@/store/hvac/service/scoredetail/index.js";
import objDetailFetch from "@/js/detail";
import {banner} from "@/store/member/index/banner.js";
import {performanceExperience} from '@/store/hvac/performance/experience.js'
import {proposalModule} from "@/store/hvac/proposal/proposal";
import {proposalProject} from "@/store/hvac/project/detail/proposal";

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        objStorageTime:{},
        timeType:0,
        app_user_id:0,
        load: false,
        loadSklo: false,
        loadType: "",
        url: "",
        upimg: null,
        userInfo: {
            name: "",
            phone: "",
            gender: "",
            cardId: "",
            birthday: "",
            address: "",
            cartData: [],
        },
        shareUserId:false,
        shareURL: "",
        loadBg: false,
        bAutorty: false,
        // position:'',
        projectInfo: {},
        //地理位置
        addresInfo: {},
        setInfo: {},
        // 艾暖通报告id
        nAntReportId: "",
        // 酷家乐id
        nFloorplanId: "",
        sorllHeight: 0,
        // 分享功能的输出key
        shareOutKey: "ut_source",
        // 用户信息（签单手）
        objSignHandInfo: {},
        // 项目案例首页滚动的高度
        scrollTop: 0,
        //服务评分--服务商id
        companyId: "",
        //服务评分--问题类型id
        questionId: "",
        //服务评分--高频问题-验收子类id
        processId: "",
        //服务评分--高频问题-验收内容id
        serviceId: "",
        //服务商项目评分时间存储
        serviceProviderDate: {startTime: "", endTime: ""},
        // 首页点击柱形图跳转高频问题
        isHomeGoQuestion: false,
        nHistoryId: 0,
        isShowShareTips:false,
    },
    actions: {
        newJson(obj, item) {
            // console.log("newJson");
            obj.commit("userHouse", {name: "7777"});
        },
        /**
         * 获取签单手信息
         * @returns {Promise<void>}
         */
        async getSignHandInfo({commit}) {
            const {result = {}} = await objDetailFetch.getInfo();
            commit({type: "SAVE_SIGN_HAND_INFO", info: result});
        },
    },
    mutations: {
        SAVE_SHARE_USER_ID(state, typePayload) {
            state.shareUserId = typePayload.share_user_id;
        },
        /**
         * 保存签单手信息
         * @param state
         * @param typePayload
         * @constructor
         */
        SAVE_SIGN_HAND_INFO(state, typePayload) {
            state.objSignHandInfo = typePayload.info;
        },
        editTimeType(state, value) {
            state.timeType = value;
        },
        editAppUserId(state, value) {
            state.app_user_id = value;
        },
        editShowShareTips(state, bool) {
            state.isShowShareTips = bool;
        },
        editObjTime(state, obj) {
            state.objStorageTime = obj;
        },
        editTime(state, obj) {
            state.serviceProviderDate = obj;
        },
        editProjectDetail(state, arr) {
            state.serviceParticulars.arrUserContractList = arr;
        },
        editScrollTop(state, companyId) {
            state.scrollTop = companyId;
        },
        editCompanyId(state, num) {
            state.companyId = num;
        },
        editQuestionId(state, num) {
            state.questionId = num;
        },
        editProcessId(state, num) {
            state.processId = num;
        },
        editServiceId(state, num) {
            state.serviceId = num;
        },
        editServiceCustomerScoring(state, arr) {
            state.serviceCustomerScoring.arrServicePowerEvaScoreList = arr;
            // console.log(arr)
        },
        // 编辑服务商表格排名数据
        editServeRank(state, arr) {
            state.serviceCustomerScoring.arrServiceRankingList = arr;
        },
        //修改高频问题列表
        editQuestionList(state, arr) {
            state.serviceCustomerScoring.arrQuestionRankList = arr;
        },
        // 编辑月度折线图数据
        editMonthScore(state, arr) {
            state.serviceCustomerScoring.arrMothScoreList = arr;
        },
        updateAntReportId(state, val) {
            state.nAntReportId = val;
        },
        updateFloorplan(state, val) {
            state.nFloorplanId = val;
        },
        loadSwitch(state, Bool) {
            // 变更状态
            if (typeof Bool == "boolean") {
                state.load = Bool;
            } else {
                state.load = false;
            }
        },
        loadSkeleton(state, Bool) {
            // 变更状态
            if (typeof Bool.bool == "boolean") {
                state.loadType = Bool.type;
                state.loadSklo = Bool.bool;
                // console.log(Bool,state)
            } else {
                state.loadSklo = false;
            }
        },
        loadAutorty(state,val){
            state.bAutorty = val;
        },
        loadBgSwitch(state, Bool) {
            if (typeof Bool == "boolean") {
                state.loadBg = Bool;
            } else {
                state.loadBg = false;
            }
        },
        setShareUrl(state, shareURL) {
            state.shareURL = shareURL;
        },
        setUserInfo(state, data = {}) {
            state.projectInfo = data;
        },
        addresInfo(state, data = {}) {
            state.addresInfo = data;
        },
        setuser(state, data = {}) {
            state.setInfo = data;
        },
        sorllHeight(state, data = {}) {
            state.sorllHeight = data;
        },
        setHistoryId(state, data = {}) {
            state.nHistoryId = data;
        },
        // Position(state, data) {
        //     state.position = data;
        // },
    },
    modules: {
        userShareDataView:viewIndex,
        userShareData: index,
        userReachData: userReach,
        userTurnoverData: userTurnover,
        projectDetailEvaluation: evaluation,
        projectDetailConstruction: construction,
        projectDetailCustom: custom,
        userHouseCompletion: completion,
        serviceCustomerScoring: scoring,
        serviceParticulars: particulars,
        memberProjectMapping,
        hvacMappingEntry: entry,
        banner,
        serviceScoreDetail,
        userTalkAppoint,//体验间版本1
        userTalkAppointV2,//体验间版本2
        userTalkAppointV3, // 体验间版本3
        performanceExperience,
        proposalModule:proposalProject,
        projectDetailCustomBeijingOne,
        proposal: proposalModule
    },
});
